import { Button } from '@givebutter/primitives/button';
import { faBank } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Dialog from 'components/dialog';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import PoweredByStripe from 'images/powered-by-stripe-gray.svg?react';

const VerifyBankModalContent = () => {
    const { apiUrl } = useAppState();
    const { accountId } = useCurrentAccount();

    return (
        <Dialog.Content className="max-w-[410px]">
            <div className="pb-2">
                <div className="mb-4 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-gray-100">
                    <FontAwesomeIcon icon={faBank} className="h-[20px] w-[20px] text-gray-500" />
                </div>
                <div className="flex items-center justify-between">
                    <div className="m-0 inline-block p-0 text-xl font-medium text-gray-900">
                        Connect your payout method
                    </div>
                    <div>
                        <PoweredByStripe />
                    </div>
                </div>
            </div>
            <Dialog.Body>
                <form>
                    <div>
                        <div className="pb-4">
                            <p className="text-base">
                                To start accepting payments, please connect your bank account or
                                debit card. Givebutter uses{' '}
                                <a target="_blank" href="https://stripe.com" rel="noreferrer">
                                    Stripe
                                </a>{' '}
                                to securely process and payout your funds.
                            </p>
                        </div>
                        <div>
                            <a
                                className={'block w-full'}
                                href={`${apiUrl}/dashboard/accounts/${accountId}/payment_account/connect?merchant=stripe`}
                            >
                                <Button variant="solid" className={'w-full'}>
                                    Get started with Stripe
                                </Button>
                            </a>
                        </div>
                    </div>
                </form>
            </Dialog.Body>
            <Dialog.Close />
        </Dialog.Content>
    );
};

export { VerifyBankModalContent };
